import React, { useEffect } from "react";
import { motion, useScroll, useTransform } from 'framer-motion';
import Header from '../components/Header';
import Hero from '../components/Hero';
import ScrollStrip from '../components/ScrollStrip';
import PhoneDemo from '../components/PhoneDemo';
import CommunitySection from '../components/CommunitySection';
import { CollegeAddon } from "../components/CollegeAddon";
import DownloadSection from '../components/DownloadSection';
import ContactForm from '../components/ContactForm';
import Footer from '../components/Footer';
import AuroraBackground from '../components/AuroraBackground';

const LandingPage = () => {
  const { scrollYProgress } = useScroll();
  const opacity = useTransform(scrollYProgress, [0, 0.2], [1, 0.3]);

  useEffect(() => {
    // Handle initial load or direct URL access (e.g., /info/contact)
    const hashSection = window.location.hash.substring(1); 
    const pathSection = window.location.pathname.split('/').pop();
    const section = hashSection || (pathSection !== 'info' ? pathSection : null);
    
    if (section) {
      setTimeout(() => {
        const element = document.getElementById(section);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  }, []);

  return (
    <>
      <div className="relative bg-black overflow-x-clip">
        <AuroraBackground />



        {/* Content */}
        <div className="relative z-10">
        <Header />
        
        <motion.div style={{ opacity }}>
          <Hero />
        </motion.div>

        <div id="collegeaddon">
          <CollegeAddon />
        </div>

        <ScrollStrip direction="left" />
        <ScrollStrip direction="right" />

        <div id="explore">
          <PhoneDemo />
        </div>

        <div id="community">
          <CommunitySection />
        </div>

        <div id="get-started">
          <DownloadSection />
        </div>

        <div id="contact">
          <ContactForm />
        </div>

        <Footer />
      </div>
      </div>
    </>
  );
};

export default LandingPage;
